import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { clientApi, setClientToken } from '../services/api';

export default function ClientRegister() {
  const navigate = useNavigate();
  const [form, setForm]     = useState({ name: '', email: '', password: '' });
  const [healthConsent, setHealthConsent] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms,     setShowTerms]     = useState(false);
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  function set(field) {
    return e => setForm(f => ({ ...f, [field]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) {
      setError('All fields are required.');
      return;
    }
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (!termsAccepted) { setError('Please read and accept the Terms of Service to continue.'); return; }
    if (!healthConsent) { setError('Please consent to health data processing to continue.'); return; }
    setError('');
    setLoading(true);
    try {
      const [first_name, ...rest] = form.name.trim().split(' ');
      const last_name = rest.join(' ') || '';
      const data = await clientApi.post('/auth/register', {
        first_name, last_name,
        email: form.email.trim().toLowerCase(),
        password: form.password,
        health_data_consent: true,
      });
      await setClientToken(data.token);
      navigate('/feed', { replace: true });
    } catch (err) {
      setError(err.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {showTerms && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: '#080808', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
            <button onClick={() => setShowTerms(false)} style={{ background: 'none', border: 'none', color: '#666', fontSize: 20, cursor: 'pointer', padding: 0, fontFamily: 'inherit', lineHeight: 1 }}>✕</button>
            <span style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>Terms of Service</span>
            <span style={{ width: 24 }} />
          </div>
          <iframe src="/terms" style={{ flex: 1, border: 'none', minHeight: 0 }} title="Terms of Service" />
          <div style={{ padding: '16px', borderTop: '1px solid rgba(255,255,255,0.1)', flexShrink: 0 }}>
            <button
              type="button"
              onClick={() => { setTermsAccepted(true); setShowTerms(false); }}
              style={{ width: '100%', padding: 16, background: '#D72638', border: 'none', borderRadius: 12, color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 4px 20px rgba(215,38,56,0.35)' }}
            >
              I Accept the Terms of Service
            </button>
          </div>
        </div>
      )}
    <div style={styles.container}>

      {/* Glow */}
      <div style={styles.glow} />

      <div style={styles.inner}>

        {/* Header */}
        <div style={styles.header}>
          <button onClick={() => navigate('/welcome')} style={styles.back}>← Back</button>
          <h1 style={styles.title}>Join the Community</h1>
          <p style={styles.subtitle}>Connect, share, and achieve more together.</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form}>

          {error && <div style={styles.errorBox}><span style={styles.errorText}>{error}</span></div>}

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Full Name</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Jane Smith"
              value={form.name}
              onChange={set('name')}
              autoComplete="name"
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              placeholder="jane@email.com"
              value={form.email}
              onChange={set('email')}
              autoCapitalize="none"
              autoComplete="email"
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Create a Password</label>
            <input
              style={styles.input}
              type="password"
              placeholder="Min. 6 characters"
              value={form.password}
              onChange={set('password')}
              autoComplete="new-password"
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 4 }}>
            <button
              type="button"
              onClick={() => setShowTerms(true)}
              style={{
                width: 20, height: 20, borderRadius: 5, flexShrink: 0, marginTop: 1,
                border: '2px solid', borderColor: termsAccepted ? '#D72638' : 'rgba(255,255,255,0.2)',
                background: termsAccepted ? '#D72638' : 'transparent',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              {termsAccepted && <span style={{ color: '#fff', fontSize: 13, fontWeight: 700, lineHeight: 1 }}>&#10003;</span>}
            </button>
            <span style={{ fontSize: 12, color: '#555', lineHeight: '18px' }}>
              I have read and accept the{' '}
              <button type="button" onClick={() => setShowTerms(true)} style={{ background: 'none', border: 'none', color: '#D72638', textDecoration: 'underline', cursor: 'pointer', padding: 0, fontFamily: 'inherit', fontSize: 12 }}>
                Terms of Service
              </button>
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 4 }}>
            <button
              type="button"
              onClick={() => setHealthConsent(v => !v)}
              style={{
                width: 20, height: 20, borderRadius: 5, flexShrink: 0, marginTop: 1,
                border: '2px solid', borderColor: healthConsent ? '#D72638' : 'rgba(255,255,255,0.2)',
                background: healthConsent ? '#D72638' : 'transparent',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              {healthConsent && <span style={{ color: '#fff', fontSize: 13, fontWeight: 700, lineHeight: 1 }}>&#10003;</span>}
            </button>
            <span style={{ fontSize: 12, color: '#555', lineHeight: '18px' }}>
              I consent to Win/R processing my health and fitness data (body measurements, workout logs, nutrition records) to deliver the Service.{' '}
              <a href="/privacy" style={{ color: '#D72638', textDecoration: 'underline' }}>Privacy Policy</a>
            </span>
          </div>

          <button type="submit" disabled={loading || !healthConsent || !termsAccepted} style={{ ...styles.btn, opacity: (loading || !healthConsent || !termsAccepted) ? 0.5 : 1 }}>
            {loading ? 'Creating account…' : 'Create Account'}
          </button>

        </form>

        {/* Login link */}
        <p style={styles.loginRow}>
          Already a member?{' '}
          <Link to="/client-login" style={styles.loginLink}>Log in</Link>
        </p>

      </div>
    </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#080808',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 24px',
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  },
  glow: {
    position: 'absolute',
    top: -200, left: '50%', transform: 'translateX(-50%)',
    width: 500, height: 500, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(215,38,56,0.18) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  inner: {
    position: 'relative', zIndex: 1,
    width: '100%', maxWidth: 400,
    display: 'flex', flexDirection: 'column', gap: 28,
  },
  header: {
    display: 'flex', flexDirection: 'column', gap: 8,
  },
  back: {
    background: 'none', border: 'none', color: '#555',
    fontSize: 13, cursor: 'pointer', padding: 0,
    fontFamily: 'inherit', alignSelf: 'flex-start',
    marginBottom: 4,
  },
  title: {
    margin: 0, fontSize: 28, fontWeight: 800,
    color: '#fff', letterSpacing: -0.5,
  },
  subtitle: {
    margin: 0, fontSize: 14, color: '#555', lineHeight: 1.5,
  },
  form: {
    display: 'flex', flexDirection: 'column', gap: 16,
  },
  errorBox: {
    background: 'rgba(215,38,56,0.1)',
    border: '1px solid rgba(215,38,56,0.3)',
    borderRadius: 10, padding: '12px 14px',
  },
  errorText: {
    color: '#D72638', fontSize: 13,
  },
  fieldGroup: {
    display: 'flex', flexDirection: 'column', gap: 6,
  },
  label: {
    fontSize: 12, fontWeight: 600,
    color: '#555', letterSpacing: 0.3,
    textTransform: 'uppercase',
  },
  input: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 12,
    padding: '14px 16px',
    fontSize: 15, color: '#fff',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  btn: {
    width: '100%', padding: '16px',
    background: '#D72638', border: 'none',
    borderRadius: 12, color: '#fff',
    fontSize: 16, fontWeight: 700,
    cursor: 'pointer', fontFamily: 'inherit',
    marginTop: 4,
    boxShadow: '0 4px 20px rgba(215,38,56,0.35)',
    transition: 'opacity 0.15s',
  },
  loginRow: {
    textAlign: 'center', fontSize: 13,
    color: '#444', margin: 0,
  },
  loginLink: {
    color: '#D72638', fontWeight: 600,
    textDecoration: 'none',
  },
};
